var AccessDataType;
(function (AccessDataType) {
    AccessDataType[AccessDataType["_Uncategorized"] = 0] = "_Uncategorized";
    AccessDataType[AccessDataType["Name"] = 1] = "Name";
    AccessDataType[AccessDataType["Surname"] = 2] = "Surname";
    AccessDataType[AccessDataType["SocialSecurityNumber"] = 3] = "SocialSecurityNumber";
    AccessDataType[AccessDataType["Email"] = 4] = "Email";
    AccessDataType[AccessDataType["PhoneNumber"] = 5] = "PhoneNumber";
    AccessDataType[AccessDataType["PolicyNumber"] = 6] = "PolicyNumber";
    AccessDataType[AccessDataType["CustomerNumber"] = 7] = "CustomerNumber";
    AccessDataType[AccessDataType["Adress"] = 8] = "Adress";
    AccessDataType[AccessDataType["VehicleRegistrationNumber"] = 10] = "VehicleRegistrationNumber";
    AccessDataType[AccessDataType["AnimalName"] = 11] = "AnimalName";
    AccessDataType[AccessDataType["ChildName"] = 12] = "ChildName";
    AccessDataType[AccessDataType["Attachment"] = 13] = "Attachment";
    AccessDataType[AccessDataType["PolicyObjectName"] = 14] = "PolicyObjectName";
    AccessDataType[AccessDataType["OtherPersonName"] = 20] = "OtherPersonName";
    AccessDataType[AccessDataType["OtherPersonSurname"] = 21] = "OtherPersonSurname";
    AccessDataType[AccessDataType["OtherPersonSsn"] = 22] = "OtherPersonSsn";
    AccessDataType[AccessDataType["OtherPersonEmail"] = 23] = "OtherPersonEmail";
    AccessDataType[AccessDataType["OtherPersonPhone"] = 24] = "OtherPersonPhone";
    AccessDataType[AccessDataType["OtherPersonAdress"] = 25] = "OtherPersonAdress";
    AccessDataType[AccessDataType["HealthInformation"] = 100] = "HealthInformation";
    AccessDataType[AccessDataType["FreeText"] = 101] = "FreeText";
    AccessDataType[AccessDataType["Summary"] = 102] = "Summary";
})(AccessDataType || (AccessDataType = {}));
export default AccessDataType;
//# sourceMappingURL=accessDataType.js.map